import { PipelineToolbar } from "@/components/pipeline-toolbar";
import { PipelineUI } from "./app/ui";
import { SubmitButton } from "./components/submit";
import { motion } from "motion/react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./components/ui/breadcrumb";
import { PanelLeftCloseIcon, PanelLeftOpenIcon } from "lucide-react";
import { useState } from "react";

const App: React.FC = () => {
  const [showPanel, setShowPanel] = useState(true);
  return (
    <div className="flex items-center justify-center w-screen h-screen gap-2 p-2 bg-primary">
      <motion.div className="h-full p-2 rounded-md shadow-lg bg-primary">
        <PipelineToolbar show={showPanel} setShow={setShowPanel} />
      </motion.div>
      <div className="flex flex-col flex-1 h-full gap-2">
        <header className="flex justify-between w-full p-2 border rounded-md shadow-md bg-background">
          <div className="flex items-center gap-2">
            <button onClick={() => setShowPanel(!showPanel)}>
              {showPanel ? (
                <PanelLeftCloseIcon size={18} />
              ) : (
                <PanelLeftOpenIcon size={18} />
              )}
              <span className="sr-only">{showPanel ? "Hide" : "Show"}</span>
            </button>
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>Pipelines</BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Untitled Pipeline</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
          <div className="flex items-center gap-2">
            <SubmitButton />
          </div>
        </header>
        <main className="flex-1 border rounded-md shadow-lg bg-background">
          <PipelineUI />
        </main>
      </div>
    </div>
  );
};

export default App;
